import { trackerStopApi } from "@/core/apis";

// getter types
export const TRACKER_STOPS = "trackerStops";

// action types
export const GET_TRACKER_STOPS = "getTrackerStops";

// mutation types
const SET_TRACKER_STOPS = "setTrackerStops";

const state = {
  trackerStops: []
};

const getters = {
  [TRACKER_STOPS](state) {
    return state.trackerStops;
  }
};

const actions = {
  [GET_TRACKER_STOPS](context) {
    return new Promise(resolve => {
      trackerStopApi.getAllTrackerStop().then(response => {
        context.commit(SET_TRACKER_STOPS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_TRACKER_STOPS](state, trackerStops) {
    state.trackerStops = trackerStops;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
